import { getElementDimensions } from './utils-get-element-dimensions.js';
import { d as debounce } from './debounce-CFtxQv9K.js';

class HeaderElement extends HTMLElement {
  connectedCallback() {
    this.lastScrollPosition = window.scrollY;
    this.getHeaderHeight();

    window.addEventListener('resize', debounce(this.getHeaderHeight, 100));

    this.primaryNav = this.querySelector('[data-nav-primary]');

    // Track dropdown state to prevent unwanted double toggling
    this.dropdownState = new Map();

    // Close any open dropdowns when clicking outside them
    document.addEventListener('mousedown', (event) => {
      // If clicking inside the header, do nothing (handled by other listeners)
      if (event.target.closest('header-element')) return;

      // If clicking outside the header, close any open dropdowns
      this.closeAllNavDrawers();
    });

    // Use mousedown instead of click for more immediate response
    this.primaryNav.addEventListener('mousedown', (event) => {
      // If clicking a dropdown controller, handle it differently
      const controller = event.target.closest('[data-dropdown-controller]');
      if (controller) {
        event.preventDefault();
        event.stopPropagation();

        const dropdownId = controller.getAttribute('aria-controls');
        if (!dropdownId) return;

        const dropdown = document.getElementById(dropdownId);
        if (!dropdown) return;

        // Toggle the dropdown based on its current state
        const isExpanded = controller.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          dropdown.close();
        } else {
          // Close any other open dropdowns first
          const openDropdowns = this.querySelectorAll('dropdown-element[aria-hidden="false"]');
          openDropdowns.forEach((openDropdown) => {
            if (openDropdown.id !== dropdownId) {
              openDropdown.close();
            }
          });

          this.openBackdrop();
          dropdown.open();
        }
      } else if (!event.target.closest('dropdown-element')) {
        // If clicking outside dropdown and controller, close all dropdowns
        const openDropdown = this.querySelector('dropdown-element[aria-hidden="false"]');
        if (openDropdown) openDropdown.close();
      }
    });

    // Handle other clickable elements in header
    this.addEventListener('mousedown', (event) => {
      // Skip touch devices
      if (document.documentElement.classList.contains('touch')) return;

      // If clicking inside a dropdown, do nothing
      if (event.target.closest('dropdown-element')) return;

      // If clicking on a controller, skip (handled by primary nav listener)
      if (event.target.closest('[data-dropdown-controller]')) return;

      // Otherwise, close any open dropdown
      const openDropdown = this.querySelector('dropdown-element[aria-hidden="false"]');
      if (openDropdown) openDropdown.close();
    });
  }

  /**
   * Close all dropdowns
   */
  closeAllNavDrawers() {
    this.dropdowns = this.dropdowns || this.primaryNav.querySelectorAll('dropdown-element');

    // Close all dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown.getAttribute('aria-hidden') === 'false') {
        dropdown.close();
      }
    });

    this.closeBackdrop();
  }

  /**
   * Close the backdrop
   */
  closeBackdrop() {
    const backdrop = this.querySelector('[data-backdrop-menu]');
    backdrop.setAttribute('aria-hidden', 'true');
  }

  /**
   * Open the backdrop
   */
  openBackdrop() {
    const backdrop = this.querySelector('[data-backdrop-menu]');
    backdrop.setAttribute('aria-hidden', 'false');
  }

  /**
   * Set header height in global scope and CSS var
   */
  getHeaderHeight = () => {
    const headerHeight = getElementDimensions('header-element').height;
    window.HEADER_HEIGHT = headerHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };
}

customElements.define('header-element', HeaderElement);
